<template>
  <div class="content-tab systime">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="forminput">
          <div class="table-row">
            <div class="title">{{$t('systemTime.currentDandT')}}</div>
            <span class="display-date value">{{displayTime}}</span>
          </div>
          <div class="table-row">
            <div class="title time-zone-title">{{$t('systemTime.timeZone')}}</div>
            <div class="time-zone">
              <div class="select-wrapper" v-if="!isDst">
                <q-select class="q-select timezone-type" :value="timezonetype" :options-array="timezoneOptions" @change="onTimetypeChange"></q-select>
              </div>
              <div class="select-wrapper" v-if="timezonetype === 'time'">
                <span>{{$t('systemTime.gmt')}}</span>
                <q-select class="q-select timezone-time" :value="gmtHour" :options-array="gmtHourOptions" @change="ongmtHourChange"></q-select>
                <div class="hourspace">:</div>
                <q-select class="q-select timezone-time" :value="gmtMin" :options-array="gmtMinOptions" @change="ongmtMinChange"></q-select>
              </div>
              <div class="select-wrapper" v-if="timezonetype === 'country'">
                <q-select class="q-select timezone-country" :value="manualTimeconf.selectTimeZoneCountry" :options-array="timezonesCountry" @change="onCountryChange" :title="getTimezonesTitle()"></q-select>
              </div>
            </div>
          </div>
          <div class="table-row" v-if="isDst">
            <div class="title">{{$t('systemTime.setting')}}</div>
            <div class="time-setting value">
              <div class="formRow sync-server">
                <div class="formlabel">
                  <radio :label="$t('systemTime.radiosync')" :checked="isItemChecked(2)" @click.native="onSelection(2)" v-validate :id="'radio-sync'"></radio>
                </div>
                <div class="forminput" :class="{disabled: !isItemChecked(2)}">
                  <div class="form-row dt">
                    <div class="dt-r">
                      <div class="title dt-c" style="min-width: auto; width: auto; padding-right: 10px;">{{$t('systemTime.server')}}</div>
                      <input class="dt-c" type="text" ref="server" name="server" v-model="manualTimeconf.serverUrl" v-validate.immediate="'server|required'" @keyup="onBlur" @blur="onBlur" :disabled="!isItemChecked(2)" :class="{'error': (errors.has('server') || serverInvaild) || resyncType === 'fail' }"/>
                      <span class="resync icon-refresh" @click="resync" v-if="resyncType !== 'loading'" :class="{disabled: !isItemChecked(2)}" style="transform: rotateY(180deg)"/>
                      <loading :mask=false :size="'small'" class="resync-load" v-else-if="resyncType === 'loading'"/>
                      <span class="status-icon" :class="syncStatus" v-if="resyncType === 'success' || resyncType === 'fail'"/>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="manualTimeconf.selectTimeSetting === 2 && (errors.has('server') || serverInvaild) || resyncType === 'fail'" class="errorMessage dt-c">{{syncErrorMsg}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="formRow">
                <div class="formlabel">
                  <radio :label="$t('systemTime.radiomanual')" :checked="isItemChecked(1)" @click.native="onSelection(1)" :id="'radio-manual'"></radio>
                </div>
                <div class="forminput" :class="{disabled: !isItemChecked(1)}">
                  <div class="datetimetitle" style="display: inline-block; min-width: auto;">{{$t('systemTime.dateTime')}}</div>
                  <datetime-picker class="datetime-picker" :format="dateformat" v-model="manualTimeconf.manualDate" :value="manualTimeconf.manualDate" @change="onChange" :isDisabled="manualTimeconf.selectTimeSetting === 2" @click.native="onChange"></datetime-picker>
                  <div class="divide">/</div>
                  <div class="select-wrapper">
                    <q-select :isDisabled="manualTimeconf.selectTimeSetting === 2" :value="'' + manualTimeconf.manualHour" :options-array="hourOptions" @change="onHourChange" ></q-select>
                  </div>
                  <div class="hourspace">:</div>
                  <div class="select-wrapper">
                    <q-select class="q-select" :value="'' + manualTimeconf.manualMins" :options-array="minOpitons" @change="onMinChange" :isDisabled="manualTimeconf.selectTimeSetting === 2"></q-select>
                  </div>
                  <div class="hourspace">:</div>
                  <div class="select-wrapper">
                    <q-select class="q-select" :value="'' + manualTimeconf.manualSecs" :options-array="minOpitons" @change="onSecChange" :isDisabled="!isItemChecked(1)"></q-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-row" v-else>
            <div class="title">{{$t('systemTime.setting')}}</div>
            <div class="time-setting value">
              <div class="formRow">
                <div class="formlabel">
                  <radio :label="$t('systemTime.radiomanual')" :checked="isItemChecked(1)" @click.native="onSelection(1)" :id="'radio-manual'"></radio>
                </div>
                <div class="forminput" :class="{disabled: !isItemChecked(1)}">
                  <div class="datetimetitle" style="display: inline-block; margin-right: 20px;">{{$t('systemTime.dateTime')}}</div>
                  <datetime-picker class="datetime-picker" :format="dateformat" v-model="manualTimeconf.manualDate" :value="manualTimeconf.manualDate" @change="onChange" :isDisabled="manualTimeconf.selectTimeSetting === 2" @click.native="onChange"></datetime-picker>
                  <div class="divide">/</div>
                  <div class="select-wrapper">
                    <q-select :isDisabled="manualTimeconf.selectTimeSetting === 2" :value="'' + manualTimeconf.manualHour" :options-array="hourOptions" @change="onHourChange" ></q-select>
                  </div>
                  <div class="hourspace">:</div>
                  <div class="select-wrapper">
                    <q-select class="q-select" :value="'' + manualTimeconf.manualMins" :options-array="minOpitons" @change="onMinChange" :isDisabled="manualTimeconf.selectTimeSetting === 2"></q-select>
                  </div>
                  <div class="hourspace">:</div>
                  <div class="select-wrapper">
                    <q-select class="q-select" :value="'' + manualTimeconf.manualSecs" :options-array="minOpitons" @change="onSecChange" :isDisabled="!isItemChecked(1)"></q-select>
                  </div>
                </div>
              </div>
              <div class="formRow sync-server">
                <div class="formlabel">
                  <radio :label="$t('systemTime.radiosync')" :checked="isItemChecked(2)" @click.native="onSelection(2)" v-validate :id="'radio-sync'"></radio>
                </div>
                <div class="forminput" :class="{disabled: !isItemChecked(2)}">
                  <div class="form-row dt">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('systemTime.server')}}</div>
                      <input class="dt-c" type="text" ref="server" name="server" v-model="manualTimeconf.serverUrl" v-validate.immediate="'server|required'" @keyup="onBlur" @blur="onBlur" :disabled="!isItemChecked(2)" :class="{'error': (errors.has('server') || serverInvaild) || resyncType === 'fail' }"/>
                      <span class="resync icon-refresh" @click="resync" v-if="resyncType !== 'loading'" :class="{disabled: !isItemChecked(2)}" style="transform: rotateY(180deg)"/>
                      <loading :mask=false :size="'small'" class="resync-load" v-else-if="resyncType === 'loading'"/>
                      <span class="status-icon" :class="syncStatus" v-if="resyncType === 'success' || resyncType === 'fail'"/>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="manualTimeconf.selectTimeSetting === 2 && (errors.has('server') || serverInvaild) || resyncType === 'fail'" class="errorMessage dt-c">{{syncErrorMsg}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="forminput" style="margin-bottom: 18px" v-if="isDst">
          <div class="table-row">
            <div class="title">{{$t('systemTime.dst')}}</div>
            <q-select class="q-select dst-options" :value="manualTimeconf.dstOptions" :options-array="dstOptions" @change="onDstChange" :title="getDstTitle()"></q-select>
          </div>
        </div>
        <div class="forminput" v-if="manualTimeconf.dstOptions === 1 && originalDstdata.dstOptions === 1">
          <div class="table-row" style="display: none">
            <div class="title time-zone-title">{{$t('systemTime.timeZone')}}</div>
            <span class="dst-auto">{{timezonesCountry[originalDstdata.selectTimeZoneCountry - 1].label}}</span>
          </div>
          <div class="table-row">
            <div class="title time-zone-title">{{$t('systemTime.recentDst')}}</div>
            <span class="dst-auto">{{ originalDstdata.recentDst }}</span>
          </div>
          <div class="table-row">
            <div class="title time-zone-title">{{$t('systemTime.dstOffset')}}</div>
            <span class="dst-auto">{{ originalDstdata.recentOffset }}</span>
          </div>
        </div>
        <div class="forminput" v-if="manualTimeconf.dstOptions === 2">
          <div class="table-row dst">
            <div class="title time-zone-title">{{$t('systemTime.dstStart')}}</div>
            <div class="hourspace">{{$t('systemTime.dstWeek')}}</div>
            <div class="select-wrapper">
              <q-select class="q-select" :value="'' + dstManualConfig.startDay" :options-array="dstDayOptions" @change="onDayChange('start', $event)"></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstDay')}}</div>
            <div class="select-wrapper dst-week">
              <q-select :value="'' + dstManualConfig.startWeek" :options-array="dstWeekOptions" @change="onWeekChange('start', $event)" ></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstMonth')}}</div>
            <div class="select-wrapper dst-month">
              <q-select class="q-select" :value="'' + dstManualConfig.startMonth" :options-array="dstMonthOptions" @change="onMonthChange('start', $event)"></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstHours')}}</div>
            <div class="select-wrapper">
              <q-select :value="'' + dstManualConfig.startHour" :options-array="dstHourOptions" @change="onDstHourChange('start', $event)" ></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstMinutes')}}</div>
            <div class="select-wrapper">
              <q-select class="q-select" :value="'' + dstManualConfig.startMins" :options-array="dstMinOptions" @change="onDstMinChange('start', $event)"></q-select>
            </div>
          </div>
          <div class="table-row dst">
            <div class="title time-zone-title">{{$t('systemTime.dstEnd')}}</div>
            <div class="hourspace">{{$t('systemTime.dstWeek')}}</div>
            <div class="select-wrapper">
              <q-select class="q-select" :value="'' + dstManualConfig.endDay" :options-array="dstDayOptions" @change="onDayChange('end', $event)"></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstDay')}}</div>
            <div class="select-wrapper dst-week">
              <q-select :value="'' + dstManualConfig.endWeek" :options-array="dstWeekOptions" @change="onWeekChange('end', $event)" ></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstMonth')}}</div>
            <div class="select-wrapper dst-month">
              <q-select class="q-select" :value="'' + dstManualConfig.endMonth" :options-array="dstMonthOptions" @change="onMonthChange('end', $event)"></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstHours')}}</div>
            <div class="select-wrapper">
              <q-select :value="'' + dstManualConfig.endHour" :options-array="dstHourOptions" @change="onDstHourChange('end', $event)" ></q-select>
            </div>
            <div class="hourspace">{{$t('systemTime.dstMinutes')}}</div>
            <div class="select-wrapper">
              <q-select class="q-select" :value="'' + dstManualConfig.endMins" :options-array="dstMinOptions" @change="onDstMinChange('end', $event)"></q-select>
            </div>
          </div>
          <div class="table-row dst">
            <div class="title time-zone-title">{{$t('systemTime.dstOffset')}}</div>
            <q-select class="q-select" :value="dstManualConfig.offset" :options-array="dstOffset" @change="onDstOffsetChange"></q-select>
            <div class="hourspace"></div>
            <div class="hourspace">{{$t('systemTime.dstOffsetMinutes')}}</div>
          </div>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full" :title="$t('save')" @click="onSaveClick()" :disabled="isDisabled">{{$t('save')}}</button>
      </div>
    </div>
    <popup-confirm name="modal-alert" :dialog-header="$t('warning')" :dialog-message="dialogMsg" icon="w" :onlyOk="true" ></popup-confirm>
  </div>
</template>

<script>
import moment from 'moment'
import Radio from './module/Radio'
import config from '../config'
import DatetimePicker from './module/DateTimePicker'
import qSelect from './module/Select.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'SystemTime',
  components: {
    Radio,
    config,
    DatetimePicker,
    qSelect
  },
  data () {
    return {
      modalname: 'modal-alert',
      sysCurTime: null,
      selectTimeSetting: 2,
      manualTimeconf: {
        selectTimeSetting: 2,
        selectTimeZone: '+00',
        selectTimeZoneCountry: 22,
        manualHour: 0,
        manualMins: 0,
        manualSecs: 0,
        manualDate: '',
        serverUrl: 'pool.ntp.org',
        dstOptions: 0
      },
      originalData: null,
      dateformat: 'YYYY/MM/DD',
      timeformat: 'HH:mm:ss',
      timezonetype: 'time',
      timezonesCountry: null,
      isShowLoading: false,
      isDisabled: true,
      hourOptions: [],
      minOpitons: [],
      secOptions: [],
      dstHourOptions: [],
      dstMinOptions: [],
      gmtHourOptions: [],
      gmtMinOptions: [],
      dstDayOptions: [],
      dstWeekOptions: [],
      dstMonthOptions: [],
      timezoneOptions: [
        {label: 'systemTime.bytime', value: 'time'},
        {label: 'systemTime.bycountry', value: 'country'}
      ],
      dstOptions: [
        {label: this.$t('systemTime.dstDisable'), value: 0},
        {label: this.$t('systemTime.dstAuto'), value: 1},
        {label: this.$t('systemTime.dstManual'), value: 2}
      ],
      dstOffset: [
        {label: '+60', value: 60},
        {label: '+45', value: 45},
        {label: '+30', value: 30}
        // {label: '-30', value: '-30'},
        // {label: '-45', value: '-45'},
        // {label: '-60', value: '-60'}
      ],
      dstManualConfig: {
        startDay: 'First',
        startWeek: 'Sun',
        startMonth: 'Jan',
        startHour: '00',
        startMins: '00',
        endDay: 'First',
        endWeek: 'Sun',
        endMonth: 'Jan',
        endHour: '00',
        endMins: '00',
        offset: 60
      },
      serverInvaild: false,
      haveDNS: false,
      startTime: null,
      syncTimeInterval: null,
      resyncType: '',
      isClickResync: false,
      curtimeIntervalId: null,
      curTimeUnixTime: null,
      displayTime: this.$t('systemTime.unknown'),
      isDst: true,
      recentDst: '2012/03/25, 01:00 ~ 2012/10/28, 02:00',
      recentOffset: '+60 minutes',
      manualConfig: null,
      originalDstdata: {
        dstOptions: 0,
        recentDst: '2012/03/25, 01:00 ~ 2012/10/28, 02:00',
        selectTimeZoneCountry: 22,
        recentOffset: '+90 minutes'
      },
      validDst: null,
      autoDstOffset: 0,
      getTimeInterval: null
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  beforeDestroy () {
    clearInterval(this.syncTimeInterval)
    this.syncTimeInterval = null
    clearInterval(this.curtimeIntervalId)
    this.curtimeIntervalId = null
    clearInterval(this.getTimeInterval)
    this.getTimeInterval = null
  },
  beforeMount: function () {
    var number = '0'
    this.isDst = config.productDiff[this.systemHostInfo.Product].isDst
    this.$store.commit('updateFullLoadingStatus', true)
    this.timezonesCountry = config.timezones
    if (this.isDst) {
      this.timezonetype = 'country'
    }
    this.dstDayOptions = config.dstDay
    this.dstWeekOptions = config.dstWeek
    this.dstMonthOptions = config.dstMonth
    for (let idx = 0; idx < 24; idx++) {
      number = (idx < 10) ? '0' + idx : '' + idx
      this.hourOptions.push({
        label: '' + idx,
        value: '' + idx
      })
      this.dstHourOptions.push({
        label: number,
        value: number
      })
    }
    for (let idx = 0; idx < 60; idx++) {
      number = (idx < 10) ? '0' + idx : '' + idx
      this.minOpitons.push({
        label: '' + idx,
        value: '' + idx
      })
      this.secOptions.push({
        label: '' + idx,
        value: '' + idx
      })
      this.gmtMinOptions.push({
        label: number,
        value: number
      })
      this.dstMinOptions.push({
        label: number,
        value: number
      })
    }
    for (let type = 1; type < 3; type++) {
      if (type === 1) {
        for (let idx = 12; idx > -1; idx--) {
          if (idx > 0) { // 1: -; 2: +
            number = (idx < 10) ? '0' + idx : '' + idx
            this.gmtHourOptions.push({
              label: '-' + number,
              value: '-' + number
            })
          }
        }
      } else {
        for (let idx = 0; idx < 15; idx++) {
          number = (idx < 10) ? '0' + idx : '' + idx
          this.gmtHourOptions.push({
            label: '+' + number,
            value: '+' + number
          })
        }
      }
    }
  },
  created () {
    let me = this
    this.$validator.extend('server', {
      getMessage (field, val) {
        return me.$t('errorMessage.ntpserverError')
      },
      validate (value, field) {
        var temp = /^[\w\-_.]+$/
        if (value === '') {
          me.serverInvaild = true
        } else {
          me.serverInvaild = false
        }
        if (!temp.test(value)) {
          return false
        }
        return true
      }
    })
    this.getTimeInterval = setInterval(() => {
      me.getSystemTime()
    }, 36000)
  },
  mounted: async function () {
    let dnsNum = 0
    let me = this
    if (this.isDst) {
      await this.getDstMode()
        .then((res) => {
          this.manualTimeconf.dstOptions = res.data.result.Mode
          if (me.manualTimeconf.dstOptions === 1) {
            me.timezonesCountry = config.dsttimezones
          } else {
            me.timezonesCountry = config.timezones
          }
        })
    }
    this.getData()
    if (this.sysBoard.OobManagement) {
      await this.getOobIP4Interface().then((res) => {
        if (res.data.result[0].val.enableInterface) {
          me.haveDNS = true
        } else {
          me.getDNSConfig()
            .then((response) => {
              if (response.data.result && response.data.result.length > dnsNum) {
                me.haveDNS = true
              } else {
                me.haveDNS = false
              }
            })
        }
      })
      this.haveDNS = true
    } else {
      this.getDNSConfig()
        .then((response) => {
          if (response.data.result && response.data.result.length > dnsNum) {
            this.haveDNS = true
          } else {
            this.haveDNS = false
          }
        })
    }
    await this.getNtpAdminState()
    this.getSystemTime()
    this.getTimezone()
    this.manualTimeconf.selectTimeSetting = (this.timeConfig.isNTP) ? 2 : 1
    this.originalData.selectTimeSetting = (this.timeConfig.isNTP) ? 2 : 1
  },
  watch: {
    serverUrl: function (newValue, oldValue) {
      if (oldValue !== '') {
        this.onChange()
      }
    },
    isDisabled: function (value) {
      this.$store.commit('updateDataChanged', !value)
    },
    curTimeUnixTime: function (value) {
      if (value) {
        let time = moment.unix(value).utc()
        if (this.manualTimeconf.selectTimeSetting === 2) {
          time.utcOffset(this.manualTimeconf.selectTimeZone)
        }
        this.displayTime = time.format(this.dateformat + ' ' + this.timeformat)
      } else {
        this.displayTime = this.$t('systemTime.unknown')
      }
    },
    timeConfig: {
      handler (value) {
        if (value) {
          // this.manualTimeconf.selectTimeSetting = (value.isNTP) ? 2 : 1
          this.manualTimeconf.selectTimeZone = value.timezone
          this.getCurrentTime()
        }
      },
      immediate: true,
      deep: true
    },
    lang: {
      handler (value) {
        setTimeout(() => {
          this.dstOptions = [
            {label: this.$t('systemTime.dstDisable'), value: 0},
            {label: this.$t('systemTime.dstAuto'), value: 1},
            {label: this.$t('systemTime.dstManual'), value: 2}
          ]
          this.$forceUpdate()
        }, 200)
      },
      immediate: true
    }
  },
  methods: {
    getData: async function () {
      let me = this
      this.isDisabled = true
      this.resyncType = ''
      this.getNtpAdminState()
      await this.getSystemTime()
      this.getTimezone()
      this.getNtpConfig()
        .then((res) => {
          if (res.data.error_code === 200) {
            if (res.data.result === null || (res.data.result.length === 1 && res.data.result[0].key === '0')) {
            } else {
              me.manualTimeconf.serverUrl = res.data.result[0].val.Address
            }
          }
          me.$store.commit('updateFullLoadingStatus', false)
        }).catch((err) => {
          this.$log.error(err)
          me.$store.commit('updateFullLoadingStatus', false)
        })
      setTimeout(() => {
        if (me.systemHostInfo.SupportPoE) me.setPoeSchduleSync()
      }, 2000)
      if (this.isDst) {
        this.getDstMode()
          .then((res) => {
            this.manualTimeconf.dstOptions = res.data.result.Mode
            this.originalDstdata.dstOptions = res.data.result.Mode
            if (me.manualTimeconf.dstOptions === 1) {
              me.timezonesCountry = config.dsttimezones
            } else {
              me.timezonesCountry = config.timezones
            }
          })
        this.getCurrentDst()
          .then((res) => {
            me.manualTimeconf.selectTimeZoneCountry = parseInt(res.data.result.idx) + 1
            if (me.manualTimeconf.selectTimeZoneCountry <= 0) me.manualTimeconf.selectTimeZoneCountry = 27
            me.originalDstdata.selectTimeZoneCountry = me.manualTimeconf.selectTimeZoneCountry
            if (res.data.result.data.Zoneinfo.StartDST && res.data.result.data.Zoneinfo.EndDST) {
              let startDst = res.data.result.data.Zoneinfo.StartDST.split(' ')
              me.validDst = res.data.result.data.Zoneinfo.StartDST.split(' ')
              let endDst = res.data.result.data.Zoneinfo.EndDST.split(' ')
              let Offset = res.data.result.data.Zoneinfo.StartOffset - res.data.result.data.Zoneinfo.EndOffset
              me.recentDst = startDst[0] + ', ' + startDst[1] + ' ~ ' + endDst[0] + ', ' + endDst[1]
              me.recentDst = me.recentDst.replaceAll('-', '/')
              me.recentOffset = (Offset >= 0) ? '+' + Offset + ' minutes' : Offset + ' minutes'
              me.autoDstOffset = Offset
              me.originalDstdata.recentDst = me.recentDst
              me.originalDstdata.recentOffset = me.recentOffset
            } else {
              me.recentDst = '-- ~ --'
              me.recentOffset = '--minutes'
              me.originalDstdata.recentDst = me.recentDst
              me.originalDstdata.recentOffset = me.recentOffset
            }
          })
        if (this.manualTimeconf.dstOptions === 1) {
          // recent daylight saving time
        } else if (this.manualTimeconf.dstOptions === 2) {
          this.getDstManual()
            .then((element) => {
              let res = element.data.result
              me.dstManualConfig.startDay = res.start.ordinal
              me.dstManualConfig.startWeek = res.start.week
              me.dstManualConfig.startMonth = res.start.month
              me.dstManualConfig.startHour = res.start.time.split(':')[0]
              me.dstManualConfig.startMins = res.start.time.split(':')[1]
              me.dstManualConfig.endDay = res.end.ordinal
              me.dstManualConfig.endMonth = res.end.month
              me.dstManualConfig.endWeek = res.end.week
              me.dstManualConfig.endHour = res.end.time.split(':')[0]
              me.dstManualConfig.endMins = res.end.time.split(':')[1]
              me.dstManualConfig.offset = res.offset
            })
        }
      }
      let currentTime = null
      let time = [this.timeConfig.time.YYYY, (this.timeConfig.time.MM - 1), this.timeConfig.time.DD, this.timeConfig.time.HR, this.timeConfig.time.MI, this.timeConfig.time.SE]
      this.timeConfig.isNTP ? currentTime = moment(time).utcOffset(this.timeConfig.timezone, true) : currentTime = moment(time).utcOffset(0, true)
      this.manualTimeconf.manualDate = currentTime.format('YYYY/MM/DD')
      this.manualTimeconf.manualHour = this.timeConfig.time.HR
      this.manualTimeconf.manualMins = this.timeConfig.time.MI
      this.manualTimeconf.manualSecs = this.timeConfig.time.SE
      this.originalData = JSON.parse(JSON.stringify(this.manualTimeconf))
    },
    getCurrentTime: function () {
      let currentTime = null
      let time = [this.timeConfig.time.YYYY, (this.timeConfig.time.MM - 1), this.timeConfig.time.DD, this.timeConfig.time.HR, this.timeConfig.time.MI, this.timeConfig.time.SE]
      this.timeConfig.isNTP ? currentTime = moment(time).utcOffset(this.timeConfig.timezone, true) : currentTime = moment(time).utcOffset(0, true)
      this.curTimeUnixTime = Number(currentTime.format('X'))
      this.setTimeInterval()
    },
    setTimeInterval: function () {
      if (this.curtimeIntervalId === null && this.curTimeUnixTime) {
        this.curtimeIntervalId = setInterval(() => {
          this.curTimeUnixTime += 1
        }, 1000)
      }
    },
    checkChangedItem: function () {
      let data = []
      let tempTimeZone = null
      if (this.timezonetype === 'country') {
        tempTimeZone = this.getCountryTimezone()
      } else {
        tempTimeZone = this.gmtHour + ':' + this.gmtMin
      }
      let temp = {
        date: this.manualDate,
        hour: this.manualHour,
        min: this.manualMins,
        sec: this.manualSecs,
        TimeSetting: this.selectTimeSetting,
        serverUrl: this.serverUrl,
        timezone: tempTimeZone
      }
      for (const key in temp) {
        if (temp.hasOwnProperty(key)) {
          const element = temp[key]
          if (element !== this.originalData[key]) {
            data.push(key)
          }
        }
      }
      return data
    },
    onChange: function () {
      if (this.manualTimeconf.selectTimeSetting !== this.originalData.selectTimeSetting) {
        let result = this.$compareObj(this.originalData, this.manualTimeconf)
        if (this.manualTimeconf.selectTimeSetting === 2) {
          (this.errors.count() > 0) ? result = true : result = false
        }
        this.isDisabled = result
      } else {
        let status = true
        for (const key in this.manualTimeconf) {
          const element = this.manualTimeconf[key]
          if (key !== 'selectTimeSetting') {
            if (this.manualTimeconf.selectTimeSetting === 1 && key !== 'serverUrl') {
              if (element !== this.originalData[key]) {
                status = false
              }
            } else {
              if (this.manualTimeconf.selectTimeSetting === 2 && (key === 'serverUrl' || key === 'selectTimeZone')) {
                if (element !== this.originalData[key]) {
                  status = false
                }
              }
            }
          }
        }
        this.isDisabled = status
      }
    },
    onTimetypeChange: function (value) {
      this.timezonetype = value
      this.isDisabled = false
    },
    ongmtHourChange: function (value) {
      this.manualTimeconf.selectTimeZone = value + ':' + this.gmtMin
      this.onChange()
    },
    ongmtMinChange: function (value) {
      this.manualTimeconf.selectTimeZone = this.gmtHour + ':' + value
      this.onChange()
    },
    onCountryChange: function (value) {
      this.manualTimeconf.selectTimeZoneCountry = value
      if (this.isDst) {
        let startDst = this.timezonesCountry[value - 1].StartDST.split(' ')
        this.validDst = this.timezonesCountry[value - 1].StartDST.split(' ')
        let endDst = this.timezonesCountry[value - 1].EndDST.split(' ')
        let Offset = this.timezonesCountry[value - 1].StartOffset - this.timezonesCountry[value - 1].EndOffset
        this.autoDstOffset = Offset
        if (startDst.length > 1 && endDst.length > 1) {
          this.recentDst = startDst[0] + ', ' + startDst[1] + ' ~ ' + endDst[0] + ', ' + endDst[1]
          this.recentDst = this.recentDst.replaceAll('-', '/')
          this.recentOffset = (Offset >= 0) ? '+' + Offset + ' minutes' : '-' + Offset + ' minutes'
        } else {
          this.recentDst = '-- ~ --'
          this.recentOffset = '--minutes'
        }
        this.isDisabled = false
        return
      }
      this.isDisabled = false
    },
    onDstChange: function (value) {
      this.manualTimeconf.dstOptions = value
      this.isDisabled = false
    },
    onHourChange: function (value) {
      this.manualTimeconf.manualHour = parseInt(value)
      this.onChange()
    },
    onMinChange: function (value) {
      this.manualTimeconf.manualMins = parseInt(value)
      this.onChange()
    },
    onSecChange: function (value) {
      this.manualTimeconf.manualSecs = parseInt(value)
      this.onChange()
    },
    onDayChange (time, val) {
      if (time === 'start') this.dstManualConfig.startDay = val
      if (time === 'end') this.dstManualConfig.endDay = val
      this.isDisabled = false
    },
    onWeekChange (time, val) {
      if (time === 'start') this.dstManualConfig.startWeek = val
      if (time === 'end') this.dstManualConfig.endWeek = val
      this.isDisabled = false
    },
    onMonthChange (time, val) {
      if (time === 'start') this.dstManualConfig.startMonth = val
      if (time === 'end') this.dstManualConfig.endMonth = val
      this.isDisabled = false
    },
    onDstHourChange (time, val) {
      if (time === 'start') this.dstManualConfig.startHour = val
      if (time === 'end') this.dstManualConfig.endHour = val
      this.isDisabled = false
    },
    onDstMinChange (time, val) {
      if (time === 'start') this.dstManualConfig.startMins = val
      if (time === 'end') this.dstManualConfig.endMins = val
      this.isDisabled = false
    },
    onDstOffsetChange: function (value) {
      this.dstManualConfig.offset = value
      this.isDisabled = false
    },
    resync: function () {
      this.$log.info('resync time server')
      this.resyncType = 'loading'
      this.isClickResync = true
      if (this.haveDNS) {
        this.setNtpServerStatus(false)
          .then((response) => {
            this.setNtpServerStatus(true)
              .then((res) => {
                this.startTime = new Date()
                this.checkSyncStatus(true)
              })
          })
      } else {
        this.resyncType = 'fail'
      }
    },
    checkSyncStatus: function (isResync) {
      let me = this
      me.syncTimeInterval = setInterval(() => {
        let currentTime = new Date()
        me.getNtpStatus().then((response) => {
          let status = response.data.result.ClientStatus
          if (status > 3 && status < 99) { // sync success
            me.$log.debug('sync success')
            if (isResync) {
              this.resyncType = 'success'
              me.getSystemTime()
            } else {
              me.getData()
            }
            clearInterval(me.syncTimeInterval)
          } else {
            // show error
            if ((currentTime - me.startTime) > 60000) {
              me.$log.debug('sync error')
              if (isResync) {
                this.resyncType = 'fail'
              } else {
                me.onOpen()
                me.getData()
                me.$store.commit('updateFullLoadingStatus', false)
                if (me.systemHostInfo.SupportPoE) me.setPoeSchduleSync()
              }
              clearInterval(me.syncTimeInterval)
            }
          }
        }).catch((err) => {
          me.$log.error(err)
        })
      }, this.intervalTime)
    },
    goSetTime: async function () {
      let me = this
      let temp = moment(this.manualTimeconf.manualDate)
      let timesetting = {
        YYYY: temp.year(),
        MM: temp.month() + 1, // .month() accepts numbers from 0 to 11
        DD: temp.date(),
        HR: this.manualTimeconf.manualHour,
        MI: this.manualTimeconf.manualMins,
        SE: this.manualTimeconf.manualSecs
      }
      let ntpStatus = {
        key: '1',
        val: { Address: this.manualTimeconf.serverUrl }
      }
      var tempArray = this.checkChangedItem()
      if (this.isDst) {
        await this.putDstMode(this.manualTimeconf.dstOptions)
        if (this.manualTimeconf.dstOptions === 2) await this.putDstManual(this.manualConfig)
        let tz = {
          idx: '' + (this.manualTimeconf.selectTimeZoneCountry - 1)
        }
        await this.putDstDistrict(tz)
      }
      if (tempArray.includes('timezone')) {
        let tempTimeZone = ''
        if (this.timezonetype === 'country') {
          tempTimeZone = this.getCountryTimezone()
        } else {
          tempTimeZone = this.gmtHour + ':' + this.gmtMin
        }
        if (!this.isDst) await this.setTimezone(tempTimeZone)
        /* if (this.manualTimeconf.selectTimeSetting === 2) {
          await this.setNtpServerStatus(false)
          this.setNtpServerStatus(true)
        } */
      }
      if (this.manualTimeconf.selectTimeSetting !== this.originalData.selectTimeSetting) {
        if (this.manualTimeconf.selectTimeSetting === 1) {
          if (this.isDst && this.validDst && this.validDst[0] && this.validDst[1]) {
            let dstDate = this.validDst[0].split('-')
            let dstTime = this.validDst[1].split(':')
            if (parseInt(dstDate[0]) === parseInt(timesetting.YYYY) && parseInt(dstDate[1]) === parseInt(timesetting.MM) && parseInt(dstDate[2]) === parseInt(timesetting.DD) && parseInt(timesetting.HR) === parseInt(dstTime[0])) {
              timesetting.MI += this.autoDstOffset
              while (timesetting.MI >= 60) {
                timesetting.MI -= 60
                timesetting.HR++
              }
            }
          }
          await this.setNtpServerStatus(false)
            .then((res) => {
              this.$log.debug(res)
              if (res.data.error_code === 200) {
                this.setSystemTime(timesetting)
                  .then(async (result) => {
                    if (result.data.error_code === 200) {
                      await me.saveSysConf()
                      this.getData()
                    }
                  }).catch((err) => {
                    this.$log.error(err)
                    this.$store.commit('updateFullLoadingStatus', false)
                  })
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        } else {
          await this.setNtpServerStatus(true)
            .then(async (res) => {
              if (this.originalData.serverUrl !== this.manualTimeconf.serverUrl) {
                await this.setNtpConfig(ntpStatus)
                  .then(async (result) => {
                    if (result.data.error_code === 200) {
                      this.isDisabled = true
                      this.startTime = new Date()
                      await me.saveSysConf()
                      await this.checkSyncStatus()
                    }
                  }).catch((err) => {
                    this.$log.error(err)
                    this.$store.commit('updateFullLoadingStatus', false)
                  })
              } else {
                this.isDisabled = true
                this.startTime = new Date()
                me.saveSysConf()
                await this.checkSyncStatus()
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        }
      } else {
        if (this.manualTimeconf.selectTimeSetting === 1) {
          if (this.isDst && this.validDst && this.validDst[0] && this.validDst[1]) {
            let dstDate = this.validDst[0].split('-')
            let dstTime = this.validDst[1].split(':')
            if (parseInt(dstDate[0]) === parseInt(timesetting.YYYY) && parseInt(dstDate[1]) === parseInt(timesetting.MM) && parseInt(dstDate[2]) === parseInt(timesetting.DD) && parseInt(timesetting.HR) === parseInt(dstTime[0])) {
              timesetting.MI += this.autoDstOffset
              while (timesetting.MI >= 60) {
                timesetting.MI -= 60
                timesetting.HR++
              }
            }
          }
          await this.setSystemTime(timesetting)
            .then(async (result) => {
              if (result.data.error_code === 200) {
                await me.saveSysConf()
                this.getData()
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        } else {
          await this.setNtpConfig(ntpStatus)
            .then((result) => {
              if (result.data.error_code === 200) {
                this.isDisabled = true
                this.startTime = new Date()
                me.saveSysConf()
                this.checkSyncStatus()
              }
            }).catch((err) => {
              this.$log.error(err)
              this.$store.commit('updateFullLoadingStatus', false)
            })
        }
      }
      // if (me.systemHostInfo.SupportPoE) me.setPoeSchduleSync()
    },
    onSaveClick: async function () {
      this.$log.info('onSaveClick')
      if ((this.manualTimeconf.selectTimeSetting === 2 && !this.haveDNS) || this.checkDstManual()) {
        this.onOpen()
      } else {
        this.$store.commit('updateFullLoadingStatus', true)
        await this.goSetTime()
      }
    },
    checkDstManual () {
      if (this.manualTimeconf.dstOptions !== 2) return false
      this.manualConfig = {
        'end': {
          'month': this.dstManualConfig.endMonth,
          'ordinal': this.dstManualConfig.endDay,
          'week': this.dstManualConfig.endWeek,
          'time': this.dstManualConfig.endHour + ':' + this.dstManualConfig.endMins
        },
        'start': {
          'month': this.dstManualConfig.startMonth,
          'ordinal': this.dstManualConfig.startDay,
          'week': this.dstManualConfig.startWeek,
          'time': this.dstManualConfig.startHour + ':' + this.dstManualConfig.startMins
        },
        'offset': this.dstManualConfig.offset
      }
      if (this.manualConfig['start'].month === this.manualConfig['end'].month) {
        if (this.manualConfig['start'].ordinal === this.manualConfig['end'].ordinal) {
          let dicWeek = {
            'Sun': 0,
            'Mon': 1,
            'Tue': 2,
            'Wed': 3,
            'Thu': 4,
            'Fri': 5,
            'Sat': 6
          }
          let startWeek = dicWeek[this.manualConfig['start'].week]
          let endWeek = dicWeek[this.manualConfig['end'].week]
          if (Math.abs(startWeek - endWeek) === 1) {
            let startOffset = parseInt(this.dstManualConfig.startHour) * 60 + parseInt(this.dstManualConfig.startMins)
            let endOffset = parseInt(this.dstManualConfig.endHour) * 60 + parseInt(this.dstManualConfig.endMins)
            startWeek += 1
            if ((startWeek === 7 && endWeek === 0) || (startWeek === endWeek)) {
              if (parseInt(this.dstManualConfig.endHour) === 0) {
                endOffset += 60 * 24
                if ((endOffset - startOffset) <= this.dstManualConfig.offset) return true
              }
            }
            return false
          } else if (Math.abs(startWeek - endWeek) === 0) {
            let startOffset = parseInt(this.dstManualConfig.startHour) * 60 + parseInt(this.dstManualConfig.startMins)
            let endOffset = parseInt(this.dstManualConfig.endHour) * 60 + parseInt(this.dstManualConfig.endMins)
            if (startOffset <= endOffset) {
              if ((endOffset - startOffset) <= this.dstManualConfig.offset) return true
            }
          }
          return false
        }
      }
      return false
    },
    isItemChecked: function (item) {
      return (item === this.manualTimeconf.selectTimeSetting)
    },
    onSelection: function (item) {
      this.manualTimeconf.selectTimeSetting = item
      this.onChange()
    },
    getTimezonesTitle: function () {
      if (this.timezonesCountry[this.manualTimeconf.selectTimeZoneCountry - 1]) {
        return this.timezonesCountry[this.manualTimeconf.selectTimeZoneCountry - 1].label
      } else {
        return ''
      }
    },
    getDstTitle: function () {
      let me = this
      let res = ''
      this.dstOptions.forEach(element => {
        if (element.value === me.manualTimeconf.dstOptions) res = element.label
      })
      return res
    },
    getCountryTimezone: function () {
      var result = ''
      var countryZone = this.timezonesCountry[this.manualTimeconf.selectTimeZoneCountry - 1].label
      result = countryZone.slice(countryZone.indexOf('T') + 1, countryZone.indexOf(')'))
      if (result === '') result = '+00:00'
      if (countryZone === '') {
        result = '+00:00'
      }
      return result
    },
    onBlur: function () {
      let me = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          me.isDisabled = true
        } else {
          me.onChange()
        }
      }).catch(() => {
        me.isDisabled = true
      })
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    ...mapActions([
      'getSystemTime', 'getNtpConfig', 'setNtpConfig', 'delNtpConfig', 'setSystemTime', 'getTimezone', 'setTimezone', 'getNtpStatus', 'getDNSConfig', 'setNtpServerStatus', 'getNtpAdminState', 'setPoeSchduleSync', 'getTzGroup', 'getDstMode', 'putDstMode', 'putDstManual', 'getDstManual', 'getCurrentDst', 'putDstDistrict', 'saveSysConf', 'getOobIP4Interface'
    ]),
    ...mapMutations([ 'openModal', 'closeModal' ])
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      sysBoard: state => state.module.sysBoard,
      timeConfig: state => state.module.timeConfig,
      isDataChanged: state => state.app.isDataChanged,
      intervalTime: state => state.app.intervalTime,
      showFullLoading: state => state.module.showFullLoading,
      systemHostInfo: state => state.module.systemHostInfo
    }),
    gmtHour () {
      var value = '+00'
      var zone = JSON.parse(JSON.stringify(this.manualTimeconf.selectTimeZone))
      if (zone) {
        value = zone.split(':')[0]
      }
      return value
    },
    gmtMin () {
      var value = '00'
      var zone = JSON.parse(JSON.stringify(this.manualTimeconf.selectTimeZone))
      if (zone) {
        value = zone.split(':')[1]
      }
      return value
    },
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    dialogMsg () {
      let result = ''
      if (!this.haveDNS) {
        result = this.$t('errorMessage.dnserror')
      } else {
        result = this.$t('errorMessage.ntpsyncError')
      }
      if (this.checkDstManual()) {
        result = this.$t('systemTime.dstManualWarning')
      }
      return result
    },
    syncStatus () {
      let result = ''
      if (this.resyncType === 'success') {
        result = 'icon-tick'
      } else if (this.resyncType === 'fail') {
        result = 'icon-btn_close'
      }
      return result
    },
    syncErrorMsg () {
      let result = ''
      if (!this.haveDNS && this.isClickResync) {
        result = this.$t('errorMessage.dnserror')
      } else {
        if (this.resyncType !== 'fail') {
          if (this.serverInvaild) {
            result = this.$t('errorMessage.ipAndSubnetEmpty')
          } else {
            result = this.errors.first('server')
          }
        } else {
          result = this.$t('errorMessage.ntpsyncError')
        }
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped deep>

.content-tab.systime {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    padding: 20px 10px 10px 10px;
    div.content-body-header{
      padding-left: 20px !important;
    }
    .formRow.static {
      margin-top: 10px;
    }
    .formlabel {
      /deep/ .q-radio {
        >.text {
          font-size: 14px;
          color: #000000;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
      }
    }
    .forminput {
      >.table-row {
        display: flex;
        margin-top: 20px;
        &:first-child {
          margin-top: 0px;
        }
        &:nth-child(2) {
          margin-top: 18px;
        }
        .title {
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          font-weight: 500;
          min-width: 250px;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
        .time-zone-title {
          line-height: 30px;
        }
        .display-date {
          color: #02208F;
          font-size: 14px;
          font-family: 'PingFang TC', 'Microsoft JhengHei' !important;
        }
        input {
          border: 1px solid #979797;
          border-radius: 4px;
          width: 200px;
          line-height: 30px;
          height: 30px;
          display: inline-block;
          font-size: 13px;
          color: #000000;
        }
        .time-zone {
          .select-wrapper {
            display: inline-block;
            vertical-align: middle;
          }
          span {
            font-size: 14px;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
          .hourspace {
            display: inline-block;
            margin: 0 5px;
            font-size: 14px;
            color: #000000;
            line-height: 30px;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
        }
        .time-setting {
          >.formRow {
            margin-bottom: 20px;
            .formlabel {
              font-size: 13px;
              color: #000000;
              line-height: 18px;
              .q-radio {
                margin-right: 10px;
                > .icon {
                  width: 16px;
                  height: 16px;
                }
              }
            }
            .forminput {
              margin-top: 12px;
              margin-left: 30px;
              .title {
                font-size: 13px;
                color: #000000;
                line-height: 30px;
                display: inline-block;
              }
              >.value {
                display: inline-block;
              }
              input {
                border: 1px solid #979797;
                border-radius: 4px;
                font-size: 23px;
                height: 30px;
                color: #000000;
                line-height: 30px;
                width: 182px;
              }
              .select-wrapper {
                display: inline-block;
                vertical-align: middle;
                width: 60px;
                select {
                  padding-right: 32px;
                }
              }
              .datetimetitle {
                font-size: 14px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
              .hourspace {
                display: inline-block;
                margin: 0 5px;
                font-size: 14px;
                color: #000000;
                line-height: 30px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
              .divide {
                display: inline-block;
                font-size: 14px;
                color: #000000;
                line-height: 30px;
                margin: 0 10px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
              &.disabled {
                color: #AEAEAE;
              }
            }
            &.sync-server {
              .forminput {
                margin-top: 12px;
                margin-left: 30px;
                display: block;
                .title {
                  font-size: 14px;
                  color: #000000;
                  line-height: 30px;
                  width: 100px;
                  font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
                }
                .form-row {
                  position: relative;
                }
                input {
                  border: 1px solid #979797;
                  border-radius: 4px;
                  font-size: 14px;
                  height: 30px;
                  color: #000000;
                  line-height: 30px;
                  width: 230px;
                  padding-right: 30px;
                  font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
                }
                &.disabled, &.disabled .title {
                  color: #AEAEAE;
                }
              }
            }
          }
        }
        .refresh {
          margin-left: 20px;
          vertical-align: middle;
          cursor: pointer;
          font-size: 20px;
          color: #000;
          &:hover {
            color: #89A5F4;
          }
          &:active {
            color: #2847A0;
          }
        }
        .resync {
          display: inline-block;
          cursor: pointer;
          margin-left: 10px;
          vertical-align: middle;
          font-size: 20px;
          color: #000;
          &:hover {
            color: #89A5F4;
          }
          &:active {
            color: #2847A0;
          }
          &.disabled {
            color: #AEAEAE;
            cursor: default;
            pointer-events: none;
          }
        }
        .resync-load {
          display: inline-block;
          margin-left: 10px;
          vertical-align: text-top;
          font-size: 16px;
          color: #000;
        }
        .icon-tick {
          font-size: 20px;
          color: #63B50A;
        }
        .icon-btn_close {
          font-size: 20px;
          color: #D0021B;
        }
        .status-icon {
          position: relative;
          vertical-align: middle;
          right: 60px;
        }
        .dst-auto {
          color: #02208F;
          font-size: 14px;
          font-family: 'PingFang TC', 'Microsoft JhengHei' !important;
          margin-top: 5px;
        }
      }
      .dst {
        .q-select {
          min-width: 60px;
          width: auto;
        }
        >.select-wrapper {
          display: inline-block;
          vertical-align: middle;
          min-width: 60px;
        }
        >span {
          font-size: 14px;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
        >.hourspace {
          display: inline-block;
          margin-right: 20px;
          font-size: 14px;
          color: #000000;
          line-height: 30px;
        }
      }
      /deep/ .datetime-picker {
        display: inline-block;
        input {
          font-size: 14px;
          width: 180px;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
      }
      &.disabled{
        .q-select, .q-select .display-label {
          color: #AEAEAE;
          cursor: default;
          pointer-events: none;
        }
      }
    }
    .q-select {
      width: 60px;
      height: 30px;
      vertical-align: middle;
      /deep/ .display-label {
        font-size: 14px !important;
        line-height: 28px !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
      }
      &::after {
        background-color: #000;
        top: -25px;
      }
      &.timezone-country {
        width: 350px;
      }
      &.dst-options {
        width: 300px;
      }
      &.timezone-type {
        width: auto;
        min-width: 150px;
      }
    }
    >.content-body-footer {
      top: calc(100% - 40px);
      .q-button {
        min-width: 80px;
        font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
      }
    }
    >.scrollbar-body {
      height: calc(100% - 40px);
      padding: 0px 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemTime.vue